import moment from 'moment';
import { Message } from 'primereact/message';
import { Rating } from 'primereact/rating';
import { Apartments_Types, ApartmentsTypes_AR } from "../Helper/data_static";

const view_apartment_type_ar =  function(type)
{
    switch (type) {
        case Apartments_Types.villa:
            return ApartmentsTypes_AR.villa;
            case Apartments_Types.apartment:
            return  ApartmentsTypes_AR.apartment;
            case Apartments_Types.studio:
            return  ApartmentsTypes_AR.studio;
            case Apartments_Types.chalet:
            return  ApartmentsTypes_AR.chalet;
            case Apartments_Types.hut:
            return  ApartmentsTypes_AR.hut;
            case Apartments_Types.break:
              return  ApartmentsTypes_AR.break;
            case Apartments_Types.room:
              return  ApartmentsTypes_AR.room;
          default:
              return 'شقة';
       }
}
export default view_apartment_type_ar;
export const View_date_payment = (data)=>{
    return (
        <strong >
            {moment(data.date_payment).format('yyyy-MM-DD')}
            <br></br>
            {moment(data.date_payment).format('hh:mm A')}
        </strong>
    )
}

export const View_latitude_longitude = (item)=>
{
    return item.latitude + ' , ' + item.longitude;
}
export const View_sea_distance = (item)=>
{
    return item.sea_distance + ' متر';
}
export const View_number_people = (item)=>
{
    return <>{item.number_people} <i className="pi pi-users" ></i></> ;
}
export const View_state = (item)=>{
    if(item.state)
        return  <Message severity="success" icon="pi pi-check ml-2" text="فعـــال" />
    else
        return  <Message severity="error" icon="pi pi-times ml-2" text="متـوقف" />
}
export const View_verification = (item)=>{
        return   <p >
            {item.dentity_document.map(index=>{
                return <>{index.name_identity}<br></br></>;
            })}
            {item.check? <Message severity="success" icon="pi pi-check ml-2" text="تم التحـــقق" />: <Message severity="error" icon="pi pi-times ml-2" text="لم يتم التحــقق" />}
        </p>
}
export const View_check = (item)=>{
    return   <p >
        {item.check === 0 && <Message severity="info" icon="pi pi-info-circle ml-2" text="انتظار ادخال البيانات" />}
        {item.check === 1 && <Message severity="warn" icon="pi pi-clock ml-2" text="انتظار التحقق" />}
        {item.check === 2 && <Message severity="error" icon="pi pi-times ml-2" text="بيانات غير مطابقة" />}
        {item.check === 3 && <Message severity="success" icon="pi pi-check ml-2" text={<>تم مطابقة البيانات<br></br>ملف المستخدم مكتمل</>} />}
    </p>
}
export const View_number_people_max = (item)=>
{
    return <>{item.number_people_max} <i className="pi pi-user-plus" ></i></> ;
}
export const View_rating_star = (item)=>{
    return    <Rating value={item.rating_star} readOnly  cancel={false}></Rating>

}
export const View_price = (item)=>
{
    return item.price + ' د.ل';
}
export const View_discount = (item)=>
{
    return item.discount + ' د.ل';
}
export const View_last_price = (item)=>
{
    return item.price-item.discount + ' د.ل';
}